//@ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Box,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import { get, post } from "requests";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useStoreActions, useStoreState } from "easy-peasy";
import MDFormControl from "components/MDFormControl";
import { Grid, FormControl } from "@mui/material";
import { allowSelection } from "@fullcalendar/core/internal";
import MDDatePicker from "components/MDDatePicker";

const DraggableFile = ({ file, index, handleRemoveFile }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px",
        border: "1px solid #ccc",
        backgroundColor: "white",
        marginBottom: "5px",
        cursor: "move",
      }}
    >
      <span>
        {index + 1}. {file.name}
      </span>
      <i
        style={{ cursor: "pointer", color: "red" }}
        onClick={() => handleRemoveFile(file.id)}
        className="fa fa-times"
      />
    </div>
  );
};

const GenerateDocumentModel = ({
  id,
  selectedFiles,
  showModal,
  hideModal,
  applicationId,
  categories,
  refreshDocuments,
  setIsRefreshing,
  onRemoveFile,
  setSelectedFiles,
  setAlert,
}) => {
  const [category, setCategory] = useState(null);
  const [fileName, setFileName] = useState("");
  const [description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [output, setOutput] = useState(null);
  const [message, setMessage] = useState("");

  const loadDocumentTemplate = useStoreActions(
    (actions: any) => actions.docGen.loadDocumentTemplate
  );
  const documentTemplates = useStoreState((state: any) => state.docGen.documentTemplates);
  const generateDocumentFromTemplate = useStoreActions(
    (actions: any) => actions.docGen.generateDocumentFromTemplate
  );
  const generateDocumentWithMultipleTemplates = useStoreActions(
    (actions: any) => actions.docGen.generateDocumentWithMultipleTemplates
  );

  const additionalTemplateOptions = useStoreState(
    (state: any) => state.docGen.additionalTemplateOptions
  );
  const [selectedAdditionalTemplates, setSelectedAdditionalTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [documentInputs, setDocumentInputs] = useState(null);
  const [isPDFOnly, setIsPDFOnly] = useState(false);

  useEffect(() => {
    if (id) {
      loadDocumentTemplate({ documentSource: "Deal Application", id });
    }
  }, [id, loadDocumentTemplate]);

  useEffect(() => {
    if (selectedTemplate) {
      setSelectedAdditionalTemplates([]);
      setOutput(null);
      let attachments = selectedTemplate?.value?.attachments;
      let inputs = selectedTemplate?.value?.documentInputs || {};
      const isPDFOnly =
        (attachments && attachments?.length > 0) ||
        selectedTemplate?.value?.templateType === "CUSTOM BUILT";
      setIsPDFOnly(isPDFOnly);

      if (isPDFOnly) {
        setOutput({ label: "Pdf", value: "Pdf" });
      }
      let allOptions = additionalTemplateOptions;
      const selectedOptions = populateSelectedOptions(attachments, allOptions);

      selectedOptions.forEach((option) => {
        if (option?.value?.documentInputs) {
          inputs = { ...inputs, ...option?.value?.documentInputs };
        }
      });

      setDocumentInputs(inputs);

      if (selectedOptions && selectedOptions.length > 0) {
        setOutput({ label: "Pdf", value: "Pdf" });
        setSelectedAdditionalTemplates(selectedOptions);
      }
    }
  }, [selectedTemplate]);

  const populateSelectedOptions = (attachments, allOptions) => {
    if (attachments && attachments.length > 0) {
      return attachments
        .map((attachment) => {
          const isJasperSubTemplate =
            attachment.isJasper !== undefined ? attachment.isJasper : false;
          const matchedOption = allOptions.find(
            (option) =>
              option.value.id === attachment.id &&
              isJasperSubTemplate ===
                (option?.value?.isJasper !== undefined ? option.value.isJasper : false)
          );
          return matchedOption || null;
        })
        .filter((option) => option !== null);
    } else {
      return [];
    }
  };

  const handleCloseModal = () => {
    hideModal();
    setCategory(null);
    setFileName("");
    setSelectedAdditionalTemplates([]);
    setSelectedTemplate(null);
    setOutput(null);
    setDescription("");
    setErrorMessage("");
    setDocumentInputs(null);
  };

  const handleGenerateDocument = async () => {
    if (!fileName) {
      setAlert({
        type: "Warning",
        message: `Please Fill out File Name.`,
      });

      return;
    }

    const invalidCharsRegex = /[.:]/;

    if (invalidCharsRegex.test(fileName)) {
      setAlert({
        type: "Warning",
        message: "File Name cannot contain any invalid characters",
      });
      return;
    }

    const fullFileName = `${fileName}.${output}`;

    if (selectedFiles?.some((file) => file?.name?.includes(fullFileName))) {
      setAlert({
        type: "Warning",
        message: `A file with the name "${fullFileName}" already exists.`,
      });
      return;
    }

    const params = {
      description: description,
      documentInputs: documentInputs,
      documentSource: "Deal Application",
      documentSourceId: Number(id),
      fileName: fileName,
      generateFileType: output?.value,
      templateId: selectedTemplate?.value?.id,
    };

    if (selectedAdditionalTemplates && selectedAdditionalTemplates.length > 0) {
      params["mediaList"] = selectedAdditionalTemplates?.map((template) => template?.value);
      await generateDocumentWithMultipleTemplates(params);
    } else {
      await generateDocumentFromTemplate(params);
    }

    await refreshDocuments();
    handleCloseModal();
  };
  const handleRemoveFile = (fileId) => {
    onRemoveFile(fileId);
  };

  const handleDocInputOnChange = (key, value) => {
    if (key.toLowerCase().includes("date")) {
      setDocumentInputs((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    } else {
      setDocumentInputs((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    }
  };

  return (
    <Dialog open={showModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
      <DialogTitle>Generate Document</DialogTitle>
      <DialogContent>
        {showAlert && (
          <Alert severity="info" onClose={() => setShowAlert(false)} sx={{ marginBottom: "10px" }}>
            {message}
          </Alert>
        )}

        <MDBox mb={2} mt={2} gap={2} display={"flex"} alignItems={"center"}>
          <TextField
            fullWidth
            label="Document Name"
            variant="outlined"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            error={!!errorMessage}
            helperText={errorMessage}
          />
        </MDBox>

        <MDBox mb={2}>
          <Autocomplete
            value={selectedTemplate}
            onChange={(_, newValue) => setSelectedTemplate(newValue)}
            options={documentTemplates}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField {...params} label="Select Template" variant="outlined" fullWidth />
            )}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
          />
        </MDBox>

        <MDBox>
          {documentInputs && Object.keys(documentInputs).length > 0 && (
            <MDBox>
              <MDTypography variant="h6">Document Inputs</MDTypography>
              <MDBox container marginTop={1} paddingLeft={2}>
                {Object.keys(documentInputs).map((key) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography fontSize={18} sx={{ marginRight: 2 }}>
                        {key
                          .replace(/([A-Z])/g, " $1")
                          .trim()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                        &nbsp;
                        <span className="star" style={{ color: "red" }}>
                          *
                        </span>
                      </MDTypography>
                      <MDBox>
                        {key.toLowerCase().includes("date") ? (
                          <MDDatePicker
                            input={{ placeholder: key, size: "large" }}
                            value={documentInputs[key]}
                            onChange={(date) => handleDocInputOnChange(key, date)}
                          />
                        ) : (
                          <FormControl fullWidth>
                            <TextField
                              variant="outlined"
                              size="small"
                              type={
                                key.toLowerCase().includes("number") ||
                                key.toLowerCase().includes("amount")
                                  ? "number"
                                  : "text"
                              }
                              value={documentInputs[key]}
                              onChange={(event) => {
                                handleDocInputOnChange(key, event.target.value);
                              }}
                              name={key}
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "1rem",
                                },
                              }}
                            />
                          </FormControl>
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                ))}
              </MDBox>
            </MDBox>
          )}
        </MDBox>

        {
          <MDBox mt={2} mb={2}>
            <Autocomplete
              value={output}
              onChange={(_, newValue) => {
                if (newValue?.value === "Docx") {
                  setSelectedAdditionalTemplates([]);
                }
                setOutput(newValue);
              }}
              options={[
                { label: "Pdf", value: "Pdf" },
                { label: "Docx", value: "Docx" },
              ]}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField {...params} label="Select Output Format" variant="outlined" fullWidth />
              )}
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              disabled={isPDFOnly}
            />
          </MDBox>
        }

        {selectedTemplate && output?.value === "Pdf" && (
          <MDBox mb={2}>
            <Autocomplete
              multiple
              value={selectedAdditionalTemplates}
              onChange={(_, newValue) => {
                let inputs = selectedTemplate?.value?.documentInputs || {};

                newValue?.forEach((option) => {
                  if (option?.value?.documentInputs) {
                    inputs = { ...inputs, ...option?.value?.documentInputs };
                  }
                });
                setDocumentInputs(inputs);
                setSelectedAdditionalTemplates(newValue);
              }}
              options={additionalTemplateOptions}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Additional Attachments (Optional)"
                  variant="outlined"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) => option.value === value?.value}
            />
          </MDBox>
        )}

        <MDBox mb={2}>
          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </MDBox>

        <MDBox>
          {selectedAdditionalTemplates?.length > 0 && (
            <div style={{ marginLeft: "10px", marginRight: "10px" }}>
              <MDTypography fontSize={18}>DOCUMENT ORDER PREVIEW</MDTypography>
              <div
                className="order-preview"
                style={{
                  border: "2px solid #ddd",
                  paddingLeft: "30px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  borderRadius: "5px",
                }}
              >
                <ol>
                  {selectedTemplate && (
                    <li>
                      {selectedTemplate?.label
                        ?.replace(/_/g, " ")
                        ?.replace(/^\w/, (c) => c.toUpperCase())}
                    </li>
                  )}

                  {selectedAdditionalTemplates.length > 0 &&
                    selectedAdditionalTemplates.map((template, index) => (
                      <li key={index}>
                        {template?.label?.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())}
                      </li>
                    ))}
                </ol>
              </div>
            </div>
          )}
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton onClick={handleCloseModal} color="secondary">
          Cancel
        </MDButton>
        <MDButton onClick={handleGenerateDocument} color="primary">
          Submit
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default GenerateDocumentModel;
